export const RATE_ACTION = {
  ThumbsUp: 'ThumbsUp',
  ThumbsDown: 'ThumbsDown'
};

export const RATING_ACTIONS_MAP = {
  [RATE_ACTION.ThumbsUp]: {
    ratingValue: 1
  },
  [RATE_ACTION.ThumbsDown]: {
    ratingValue: 0
  }
};
